var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpotDown2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3271 11.314C22.3269 11.7141 22.0024 12.0384 21.6023 12.0384L1.024 12.0379C0.731012 12.0379 0.466949 11.8614 0.354921 11.5908C0.242893 11.3201 0.304958 11.0085 0.512179 10.8013L6.11778 5.19569C6.40077 4.91271 6.85948 4.9126 7.14234 5.19546C7.4252 5.47832 7.4251 5.93704 7.14211 6.22002L2.77311 10.589L21.603 10.5895C22.0031 10.5895 22.3273 10.9138 22.3271 11.314Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.470978 10.8425C0.731328 10.5821 1.16638 10.5951 1.44269 10.8714L7.98455 17.4133C8.26086 17.6896 8.2738 18.1246 8.01345 18.385C7.7531 18.6453 7.31805 18.6324 7.04174 18.3561L0.499882 11.8142C0.22357 11.5379 0.210629 11.1028 0.470978 10.8425Z",
    fill: "#3A3A3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotDown2);
export default __webpack_public_path__ + "static/media/spot_down_2.907980dde9d0312f2f9cc0c01ebdc336.svg";
export { ForwardRef as ReactComponent };